/* NÛREN CIRCLE — interactions des sections Nûren */
(function () {
  if (window.NurenInit) return;

  var pad = function (n) { return String(n).padStart(2, '0'); };

  function initCountdowns(root) {
    root.querySelectorAll('[data-nr-countdown]').forEach(function (cd) {
      if (cd.dataset.nrReady) return;
      cd.dataset.nrReady = '1';
      var t1 = Date.parse(cd.dataset.target1 || '');
      var t2 = Date.parse(cd.dataset.target2 || '');
      if (isNaN(t1)) { cd.hidden = true; return; }
      var d = cd.querySelector('[data-d]'), h = cd.querySelector('[data-h]'), m = cd.querySelector('[data-m]');
      var cap = cd.querySelector('[data-cap]');
      function tick() {
        var now = Date.now();
        var first = now < t1;
        var target = first ? t1 : t2;
        var diff = target - now;
        if (isNaN(target) || diff <= 0) {
          cd.innerHTML = '<p class="nr-cd-caption" style="max-width:none">' + (cd.dataset.done || '') + '</p>';
          clearInterval(timer);
          return;
        }
        d.textContent = pad(Math.floor(diff / 864e5));
        h.textContent = pad(Math.floor(diff / 36e5) % 24);
        m.textContent = pad(Math.floor(diff / 6e4) % 60);
        if (cap) cap.textContent = first ? (cd.dataset.cap1 || '') : (cd.dataset.cap2 || '');
      }
      var timer = setInterval(tick, 30000);
      tick();
    });
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('nr-in'); io.unobserve(e.target); } });
  }, { threshold: 0.2 }) : null;
  function initReveal(root) {
    root.querySelectorAll('.nr-reveal').forEach(function (el) { io ? io.observe(el) : el.classList.add('nr-in'); });
  }

  function initGallery(root) {
    root.querySelectorAll('[data-nr-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-nr-main]');
      g.querySelectorAll('[data-nr-thumb]').forEach(function (b) {
        b.addEventListener('click', function () {
          g.querySelectorAll('[data-nr-thumb]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          if (main) { main.src = b.dataset.src; main.srcset = b.dataset.srcset || ''; main.alt = b.dataset.alt || ''; }
        });
      });
    });
  }

  function initProduct(root) {
    root.querySelectorAll('[data-nr-product]').forEach(function (p) {
      var price = p.querySelector('[data-nr-price]');
      var compare = p.querySelector('[data-nr-compare]');
      var quarter = p.querySelector('[data-nr-quarter]');
      var label = p.querySelector('[data-nr-variant-label]');
      var btn = p.querySelector('[data-nr-buy]');
      var btnText = btn ? btn.dataset.text : '';
      var soldText = btn ? btn.dataset.sold : '';
      p.querySelectorAll('input[name="id"][type="radio"]').forEach(function (r) {
        r.addEventListener('change', function () {
          if (price) price.textContent = r.dataset.price;
          if (compare) { compare.textContent = r.dataset.compare || ''; compare.hidden = !r.dataset.compare; }
          if (quarter) quarter.textContent = r.dataset.quarter;
          if (label) label.textContent = r.dataset.title;
          if (btn) { var ok = r.dataset.available === 'true'; btn.disabled = !ok; btn.textContent = ok ? btnText : soldText; }
          if (r.dataset.image) {
            var main = p.querySelector('[data-nr-main]');
            if (main) { main.src = r.dataset.image; main.srcset = ''; }
          }
        });
      });
    });

    var bars = document.querySelectorAll('[data-nr-mbar]');
    if (!bars.length) return;
    var onScroll = function () {
      bars.forEach(function (bar) {
        var target = document.getElementById(bar.dataset.target);
        if (!target) return;
        var r = target.getBoundingClientRect();
        var visible = r.top < innerHeight && r.bottom > 0;
        bar.classList.toggle('nr-on', scrollY > innerHeight * 0.8 && !visible);
      });
    };
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initFilters(root) {
    root.querySelectorAll('[data-nr-filters]').forEach(function (f) {
      f.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          f.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          var cat = b.dataset.filter;
          document.querySelectorAll('[data-nr-cat]').forEach(function (it) {
            it.hidden = !(cat === 'all' || it.dataset.nrCat === cat);
          });
        });
      });
    });
  }

  function initVideoModal(root) {
    root.querySelectorAll('[data-nr-play]').forEach(function (btn) {
      if (btn.dataset.nrReady) return;
      btn.dataset.nrReady = '1';
      btn.addEventListener('click', function () {
        var sec = btn.closest('section') || document;
        var modal = sec.querySelector('[data-nr-modal]');
        var tpl = document.getElementById(btn.dataset.nrPlay);
        if (!modal || !tpl) return;
        var body = modal.querySelector('[data-nr-modal-body]');
        body.innerHTML = '';
        body.appendChild(tpl.content.cloneNode(true));
        if (modal.showModal) modal.showModal(); else modal.setAttribute('open', '');
        var v = body.querySelector('video');
        if (v) { v.setAttribute('playsinline', ''); var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      });
    });
    root.querySelectorAll('[data-nr-modal]').forEach(function (modal) {
      if (modal.dataset.nrReady) return;
      modal.dataset.nrReady = '1';
      var close = function () { if (modal.close) modal.close(); else modal.removeAttribute('open'); };
      modal.querySelector('[data-nr-modal-close]').addEventListener('click', close);
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      modal.addEventListener('close', function () { modal.querySelector('[data-nr-modal-body]').innerHTML = ''; });
    });
  }

  function init(root) {
    root = root || document;
    initCountdowns(root);
    initReveal(root);
    initGallery(root);
    initProduct(root);
    initFilters(root);
    initVideoModal(root);
  }

  window.NurenInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Éditeur de thème : réinitialiser quand une section est modifiée
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
